export const primaryColor = '#00B96D';
export const alertColor = '#ff0000';
